module.exports = __webpack_public_path__ + "static/media/icon_kijkwijzer_taal.0ec5f23e.svg";